import { validateAndConvertFraction } from "../../../../shared/util/validateFunction"
import { compareStringsAccentInsensitive } from "../../../../shared/util/compare"
import { validateAndFormatNumber } from "../../../../stateManagement/redux/slices/gerencia_tecnica/auxiliarFunctions"
import { gerenciaTecnicaState, originalFlowUpload, validationTypeEnum, allowTests, allowWellOperationStates } from "../../../../stateManagement/redux/slices/gerencia_tecnica/interfaces"
import { projectList } from "../../../../shared/util/projectList";

export interface CheckErrorsProps {
    mainState: gerenciaTecnicaState,
    executedDate: any,
    activeFieldForActivities: string,
    cuadrillas: any[],
    setSortActivities: any,
    setErrors: any,
    setFilterStates: any,
    filterStates: any,
    originalFlow: string,
    numeroCuadrilla: any,
    groupAssigned: any
}

export const checkErrors = ({ mainState, executedDate, activeFieldForActivities, cuadrillas, setSortActivities, setErrors, setFilterStates, filterStates, originalFlow, numeroCuadrilla, groupAssigned }: CheckErrorsProps) => {
    const validation = mainState.taskValidations || []

    const homologations: any[] = []


    validation.forEach((v) => {
        if (v.homologation) {
            v.homologation.forEach((h) => {
                homologations.push({ target: v.name, origin: h })
            })
        }
    })

    const errors: any = {}

    const users: any = []

    const addError = (fileName: string, error: string, type: 'error' | 'warning', variable: string, valueWithError: string) => {


        const checkIfExist = errors[fileName]

        if (!checkIfExist) {
            errors[fileName] = [{ error, type, variable, valueWithError }]
        } else {
            const checkIfExist = errors[fileName].find((x: any) => x.error === error);
            if (!checkIfExist) {
                errors[fileName].push({ error, type, variable, valueWithError })
            }
        }
    }

    if (!cuadrillas || cuadrillas.length === 0) {
        addError('General', 'No se han encontrado actividades a cargar', 'error', "Cuadrillas", "")
    } else if (cuadrillas.length > 1) {
        addError('General', 'Solo se puede cargar una cuadrilla a la vez y se ha detectado 2 grupo de nombres distintos', 'error', "Cuadrillas", "")
    }


    if (executedDate === null) {
        addError('General', 'No se ha seleccionado una fecha de ejecucion', 'error', "Fecha", "")
    }

    const validatedActivities = []

    const allLocations = mainState.locations

    for (const activity of mainState?.activitiesWithCarts || []) {

        const fileName = activity['fileName']

        let location;

        if (activeFieldForActivities === '') {
            addError("General", 'No se ha seleccionado un campo', 'error', "Campo", "")
        } else {
            const locationNameWithfield = validateAndFormatNumber(activity.Pozo, activeFieldForActivities)

            location = allLocations?.find(location => location.name === locationNameWithfield)

            if (!location) {
                addError(fileName, `Location with ID ${activity.Pozo} not found`, 'error', "Pozo", activity.Pozo)
                continue
            }
        }

        // pending ValidateUsers

        for (const cuadrilla of cuadrillas) {

            const cuadrillaMembers = cuadrilla.member.split('/').map((m: string) => m.trim())

            cuadrillaMembers.forEach((member: string) => {
                const user = mainState.users?.find((u) => compareStringsAccentInsensitive(u.name, member))

                if (!user) {
                    addError(fileName, `NE-001 El nombre del usuario ${member} no se encuentra registrado y sera registrado como invitado, por lo cual no le contara la actividad en el desempeño`, 'warning', "Ingenieros", member)
                }

                const userToAdd = {
                    id: user?.id || 'guest',
                    name: user?.name || member,
                }

                if (!users.find((u: any) => u.id === userToAdd?.id)) {
                    users.push(userToAdd)
                }

            })
        }

        const existAtLestOneUserFromDb = users.find((u: any) => u.id !== 'guest')

        if (!existAtLestOneUserFromDb) {
            addError(fileName, `No se ha encontrado ningun usuario registrado en el sistema, se requiere almenos un usuario para poder cargar la actividad`, 'error', "Ingenieros", "")
        }

        // validate Variables

        const variablesToOmit = ['Pozo', 'haveCart', 'taskId', 'Campo', 'originFlow', 'fileName', 'Fecha', "type", "location", "position", "POT (BNPD)", "POT", "POT. (BNPD)", "Sector", "Cuadrilla #", "Cuadrilla"]

        const variableToAddWithoutValidation = ["dynCarts"]

        const variables: any[] = []

        let tipoActividad = activity['Tipo Actividad']

        if (!tipoActividad) {
            const cleankeyForTypeOfActivity = homologations.filter((h) => h.target === "Tipo Actividad")
            cleankeyForTypeOfActivity.forEach((c) => {
                if (activity[c.origin]) {
                    tipoActividad = activity[c.origin]
                }
            })
        }


        for (const key of Object.keys(activity)) {

            let cleanKey = key

            if (variablesToOmit.includes(key.trim())) {
                continue
            }
            let variableValidation = validation.find((v) => v.name === key)

            if (!variableValidation) {

                cleanKey = key.trim().replace(/[\r\n]/g, '')

                const validateHomologation = homologations.find((h) => h.origin === cleanKey)

                if (validateHomologation) {

                    variableValidation = validation.find((v) => v.name === validateHomologation.target)
                } else {

                    if (!variableToAddWithoutValidation.includes(cleanKey)) {
                        addError(fileName, `Variable ${key} no encontrada en la lista de variables`, 'warning', key, "")
                        continue
                    }

                }
            }

            let value = activity[key]

            try {

                if (typeof value === 'string' && value?.toLowerCase() === "s/i" && tipoActividad === "Revisión") {
                    continue
                }

                if (variableValidation?.validationType === validationTypeEnum.boolean) {

                    value = value?.toLowerCase() === 'si' ? 'true' : value?.toLowerCase() === 'no' ? 'false' : value

                    if (value !== 'true' && value !== 'false') {
                        addError(fileName, `Variable ${key} con valor ${value} debe ser un valor TRUE o FALSE`, 'error', key, value)
                        continue
                    }
                } else if (variableValidation?.validationType === validationTypeEnum.number) {

                    if (isNaN(Number(value))) {
                        addError(fileName, `Variable ${key} con valor ${value} debe ser un un numero`, variableValidation?.required ? 'error' : 'warning', key, value)
                    }
                } else if (variableValidation?.validationType === validationTypeEnum.fraction) {

                    const isFraction = validateAndConvertFraction(value)

                    if (!isFraction) {
                        addError(fileName, `Variable ${key} con valor ${value} debe ser un una fraccion estilo A de B o A / B`, variableValidation?.required ? 'error' : 'warning', key, value)
                        continue
                    } else {
                        value = isFraction
                    }
                } else if (variableValidation?.validationType === validationTypeEnum.date) {
                    if (isNaN(Date.parse(value))) {
                        addError(fileName, `Variable ${key} con valor ${value} debe ser una fecha valida`, variableValidation?.required ? 'error' : 'warning', key, value)
                        continue
                    }
                } else if (variableValidation?.validationType === validationTypeEnum.list) {
                    value = value.trim()
                    const option = variableValidation.options.find(option => option?.value?.toLowerCase()?.trim() === value?.toLowerCase()?.trim())
                    if (!option) {
                        addError(
                            fileName,
                            `Variable ${key} con valor ${value} debe tener un valor de : ${variableValidation.options.length > 10 ? variableValidation.options.splice(0, 10).map(option => option.value).join(', ') : variableValidation.options.map(option => option.value).join(', ')}`,
                            variableValidation?.required ? 'error' : 'warning',
                            key,
                            value
                        )
                        continue
                    } else {
                        value = option.value
                    }
                } else {

                    if (!value || value === '' || `${value}`?.includes('NaN:NaN')) {
                        addError(fileName, `Variable ${key} con valor ${value} debe tener un valor valido`, variableValidation?.required ? 'error' : 'warning', key, value)
                        continue
                    }
                }

                // if (variableValidation?.name === 'dynCarts' && value === '[]' || (key === 'dynCarts')) {
                //     continue
                // }

                variables.push({
                    id: variableValidation?.id,
                    name: variableValidation?.name,
                    value: value,
                    validationType: variableValidation?.validationType
                })

            } catch (error) {

                addError(fileName, `Variable ${key} con valor ${value} debe tener un valor valido`, variableValidation?.required ? 'error' : 'warning', key, value)
                continue
            }


        }

        // TODO validate custom variables deppending on the flow and others variables 

        const carta = activity['Carta'] || "No"

        const nivel = activity['Nivel'] || "No"

        const pp = activity['Prueba Presión'] || "No"

        const pv = activity['Prueba de Válvula'] || "No"

        const originFlow = originalFlowUpload.find((f) => f.id === originalFlow)

        const typeOfActivitiesByOriginFlow = originFlow?.typeOfActivities

        const cards = mainState?.cardsWithActivities || []

        let cardWasFound = false
        let liquidLevelWasFound = false

        if (!typeOfActivitiesByOriginFlow?.includes(tipoActividad)) {

            addError(fileName, `Tipo de actividad ${tipoActividad} no permitida para el flujo seleccionado ${originFlow?.name}, solo se permiten ${typeOfActivitiesByOriginFlow?.join(' , ')}`, 'error', "Tipo Actividad", tipoActividad)
        }

        const allowTestConfig = allowTests.find((a) => a.typeOfActivity === tipoActividad)

        if (allowTestConfig?.carta.includes(carta.toLowerCase()) === false) {
            addError(fileName, `El valor tildado para Carta "${carta}" no esta permitido para el tipo de actividad ${tipoActividad}`, 'error', "Carta", carta)
            cardWasFound = false
        } else {
            cardWasFound = true
        }

        if (allowTestConfig?.nivel.includes(nivel.toLowerCase()) === false) {
            addError(fileName, `El valor tildado para Nivel "${nivel}" no esta permitido para el tipo de actividad ${tipoActividad}`, 'error', "Nivel", nivel)
            liquidLevelWasFound = false
        } else {
            liquidLevelWasFound = true
        }

        if (allowTestConfig?.pp.includes(pp.toLowerCase()) === false) {
            addError(fileName, `El valor tildado para Prueba de presion "${pp}" no esta permitido para el tipo de actividad ${tipoActividad}`, 'error', "Prueba Presion", pp)
        }

        if (allowTestConfig?.pp.includes(pv.toLowerCase()) === false) {
            addError(fileName, `El valor tildado para Prueba de valvula "${pv}" no esta permitido para el tipo de actividad ${tipoActividad}`, 'error', "Prueba Valvula", pv)
        }

        if (carta?.toLowerCase() === "si" && activity['haveCart'] === false) {
            addError(fileName, `No se ha podido leer el archivo de carta para la locacion "${activity.Pozo} pero se ha marcado que se realizo carta, favor revisar" `, 'error', "Carta", carta)
            cardWasFound = true
        }

        if (carta?.toLowerCase() === "no" && activity['haveCart'] === true) {
            addError(fileName, `Se ha encontrado un archivo para la locacion "${activity.Pozo} pero se tildo que no se realizo carta, favor revisar" `, 'error', "Carta", carta)
            cardWasFound = false
        }

        if (tipoActividad === "Estudio Completo" && (!cardWasFound || !liquidLevelWasFound)) {
            addError(fileName, `Se ha marcado  Estudio Completo pero este requiere realizar estudios de carta y nivel, pero fue marcado para carta ${cardWasFound ? "Si" : "No"}, Nivel ${liquidLevelWasFound ? "Si" : "No"} `, 'error', tipoActividad, tipoActividad)
        }

        const reespaceo = activity['Reespaceo'] || ""

        const eptAnterior = variables.find((v) => v.name === "EPT-Anterior")?.value ?? ""

        const eptPosterior = variables.find((v) => v.name === "EPT-Posterior")?.value ?? ""

        if (reespaceo.toLowerCase() === "si") {
            if (isNaN(eptAnterior) || isNaN(eptPosterior) || eptAnterior === "" || eptPosterior === "") {
                addError(fileName, `Variable Reespaceo marcada como "SI", se requiere que se llene los campos EPT Anterior ${eptAnterior} y EPT Posterior ${eptPosterior}`, 'error', "Reespaceo", reespaceo)
            }
        }

        const initialState = variables.find((v) => v.name === "Estado Pozo Inicial")?.value || ""

        const finalState = variables.find((v) => v.name === "Estado Pozo Final")?.value || ""

        const allowFinalStates = allowWellOperationStates.find((a) => a.initialState === initialState)

        if (!allowFinalStates) {
            addError(fileName, `No se ha encontrado un estado inicial valido para el pozo ${initialState}`, 'error', "Estado Pozo Inicial", initialState)
        } else {
            if (!allowFinalStates.finalState.includes(finalState)) {
                addError(fileName, `No se ha encontrado un estado final valido, se selecciono ${initialState} como estado inicial y como final ${finalState}, pero para este caso solo pueden ser un estado final valido ${allowFinalStates.finalState.join(' , ')}`, 'error', "Estado Pozo Final", finalState)
            }
        }

        const THP = variables.find((v) => v.name === "THP")?.value || "S/I"

        if (['Aportando', 'Operando'].includes(finalState) && THP === 0) {

            addError(fileName, `El pozo se encuentra en estado ${finalState} y el valor de THP es 0, favor revisar, si no logro registrar el valor de THP puede colorcar S/I`, 'error', "THP", THP)
        }


        if (['IT', 'Sin Aporte', 'Sin Producción'].includes(finalState) && THP > 0) {

            addError(fileName, `El pozo se encuentra en estado ${finalState} y el valor de THP es de ${THP}, favor revisar, si no logro registrar el valor de THP puede colorcar S/I pero no es posible cargar thp positivo en un estado no operativo`, 'error', "THP", THP)
        }

        const isOkForEchometer = variables.find((v) => v.id === "7f5efd15-536f-11f0-82be-00505652cca1")?.value

        const isRequiredForEchometer = validation.find((v) => v.id === "7f5efd15-536f-11f0-82be-00505652cca1")
        
        if (['Sin Aporte', 'Sin Producción'].includes(finalState) && !isOkForEchometer && isRequiredForEchometer) {

            addError(fileName, `El pozo ${location?.name} se encuentra en estado ${finalState} y no se ha reportado valor para 'Apto para Estudio Completo', se requiere valide frenos y sonolog, favor revisar y colocar si o no en el pozo`, 'error', "isOkForEchometer", isOkForEchometer)
        }

        const isOKItReasons = variables.find((v) => v.name === "Sub Estado IT")?.value

        console.log({isOKItReasons, finalState, variables})

        if (["it","IT"].includes(finalState) && !isOKItReasons ) {
            addError(fileName, `El pozo ${location?.name} se encuentra en estado ${finalState} y no se ha reportado valor para 'Sub Estado IT', se requiere colocar el motivo IT, favor revisar y colocar el motivo IT`, 'error', "isOKItReasons", isOKItReasons)
        }

        const hasTecnologia = variables.findIndex((v) => v.id === '6d7ad753-bb56-479a-ac5c-d26039113564')

        if (hasTecnologia !== -1) {
            variables[hasTecnologia].value = originFlow?.name
        } else {
            variables.push({
                id: '6d7ad753-bb56-479a-ac5c-d26039113564',
                name: 'Tecnologia',
                value: originFlow?.name,
                validationType: validationTypeEnum.string
            })
        }


        const hasCuadrilla = variables.findIndex((v) => v.id === '290aa7b7-299e-48e6-bcae-ad9e083c5cac')

        if (hasCuadrilla !== -1) {
            variables[hasCuadrilla].value = numeroCuadrilla
        } else {
            variables.push({
                id: '290aa7b7-299e-48e6-bcae-ad9e083c5cac',
                name: 'Cuadrilla',
                value: numeroCuadrilla || 0,
                validationType: validationTypeEnum.number
            })
        }

        const requiredVariables = validation.filter((v) => v.required)


        requiredVariables.forEach((v) => {
            const exist = variables.find((x) => x.name === v.name)

            if (!exist && (tipoActividad !== "Revisión" || originalFlow === "f63fbc29-2a0b-11f0-bbe6-00505652cca1")) {
                addError(fileName, `Variable ${v.name} es requerida`, 'error', v.name, "")
            }
        })

        const activeProject = projectList.find((f) => f.id === activeFieldForActivities)?.projectId


        const cuadrilla = variables.find((v) => v.id === '290aa7b7-299e-48e6-bcae-ad9e083c5cac')?.value

        const cargaMax = variables.find((v) => v.id === "a80ef654-8fa6-43a0-bd69-fec7abae73cb")?.value

        const cargaMin = variables.find((v) => v.id === "0f0fdd0f-2d3c-4a8e-adc2-98303927c6c3")?.value

        const comentario = variables.find((v) => v.name === "Comentario")?.value || ""

        if (comentario && comentario.length < 20) {

            addError(fileName, `En el pozo ${location?.name} el comentario tiene un largo de ${comentario.length} caracteres, el comentario minimo permitido es 20 caracteres`, 'error', "Comentario", comentario)
        }


        if (cargaMax !== undefined && cargaMin !== undefined) {
            if (isNaN(Number(cargaMax)) || isNaN(Number(cargaMin))) {

            } else if (Number(cargaMax) <= Number(cargaMin)) {
                addError(fileName, `La variable Carga Maxima ${cargaMax} debe ser mayor que Carga Minima ${cargaMin}`, 'error', "Carga", "")
            }
        }

        if (!cuadrilla) {
            addError(fileName, `Variable Cuadrilla no encontrada y es requerida`, 'error', "Cuadrilla", "")

        } else {
            const originFlow = activity['originFlow']

            variables.push({
                id: '81b17835-04e6-4783-9469-45734e697993',
                name: 'POT',
                value: location?.['pot'] || 0,
                validationType: validationTypeEnum.number
            })

            // Sector

            variables.push({
                id: '6f6fae94-64c2-4cef-8da8-158f578ed8c0',
                name: 'Sector',
                value: location?.['zone'] || 0,
                validationType: validationTypeEnum.string
            })

            let startTime = variables.find((v) => v.id === "e6897d36-55a0-4e46-acf0-e0ecfade4994")?.value || "00:00"

            startTime = startTime.replace(/:/g, "_").replace(/ /g, "_");

            const fieldId = `${location?.name}-${originFlow}-${numeroCuadrilla}-${startTime}`

            validatedActivities.push({
                originFlowId: originFlow,
                groupAssigned,
                projectId: activeProject,
                locationId: location?.id,
                taskId: "",
                fieldId,
                users,
                variables
            })
        }
    }


    for (const card of mainState?.cardsWithActivities || []) {
        if (!card.haveActivity) {
            addError('General', `Carta identificado con ${card.location} no se pudo asociar a una actividad`, 'error', "Carta", "")
        }
    }


    setSortActivities(validatedActivities)

    setErrors(errors)

    let errorsAmount = 0

    Object.keys(errors).forEach((key) => errorsAmount = errorsAmount + errors[key].length)

    setFilterStates([...filterStates.map((f: any) => {
        if (f.id === 'errors') {
            f.amountElement = errorsAmount
        }
        return f
    })])
}